/**
 * How a Plaid connection's health is shown.
 *
 * The API reports the raw enum (`Active`, `RequiresReauth`, `Error`,
 * `Disconnected`). `RequiresReauth` is the one that matters most and reads
 * worst as a raw value: it means "the bank wants a fresh sign-in", and the
 * only fix is the owner running Reconnect. The words shown for each code live
 * in the message catalog, connection-messages.ts (issue #29).
 */
export interface ConnectionHealth {
  status: string;
  last_error_code?: string | null;
}

export const NEEDS_REAUTH = 'RequiresReauth';

/** Whether this connection needs its owner to sign in to the bank again. */
export const needsReauth = (c: ConnectionHealth): boolean => c.status === NEEDS_REAUTH;
